import Icon from "@/components/atoms/Icon";
import type { Address as GraphQLAddressType } from "@/graphql/sdk/__generated__";
import { cn } from "@/helpers/className";
import { AllowedLanguages } from "@/types/generic";

interface AddressProps {
  address: GraphQLAddressType;
  className?: string;
  iconClassName?: string;
  iconWrapperClassName?: string;
  locale: AllowedLanguages;
  showDirectionsLink?: boolean;
}

export const Address = ({
  address,
  className,
  iconClassName,
  iconWrapperClassName,
  locale,
  showDirectionsLink = false,
}: AddressProps) => {
  const i18n = {
    [AllowedLanguages.Nl]: {
      directions: "Routebeschrijving",
    },
    [AllowedLanguages.Fr]: {
      directions: "Itinéraire",
    },
    [AllowedLanguages.En]: {
      directions: "Directions",
    },
  };

  const getDirectionsUrl = function (address: GraphQLAddressType) {
    const { street, number, box, postal_code, locality } = address;

    let addressString = `${street}+${number}`;

    if (box) {
      addressString += `+${box}`;
    }

    addressString += `+${postal_code}+${locality}`;

    return `https://www.google.com/maps/dir/?api=1&destination=${addressString}`;
  };

  return (
    <div className={cn("mb-1 grid text-xs text-gray-500", className)}>
      <span
        className={cn(
          "inline-flex items-center justify-center",
          iconWrapperClassName,
        )}
      >
        <Icon name="map-pin" className={cn("h-4 w-4", iconClassName)} />
      </span>
      <div className="flex items-center">
        <span>
          {`${address.street} ${address.number}`}
          {address?.box ? ` ${address.box}` : ""},{" "}
          {`${address.postal_code} ${address.locality}`}
        </span>
      </div>
      {showDirectionsLink && (
        <div className="col-start-2">
          <a
            href={getDirectionsUrl(address)}
            className="link text-medium text-md relative z-10 text-black"
            rel="noopener"
            target="_blank"
          >
            {i18n[locale].directions}
          </a>
        </div>
      )}
    </div>
  );
};
